import { createApi } from "@reduxjs/toolkit/query/react";
import { setToken } from "../../features/userSlice";
import CustomFetchBase from "../CustomFetchBase";

export const AuthApi = createApi({
  reducerPath: "AuthApi",
  baseQuery: CustomFetchBase,
  endpoints: (builder) => ({
    // admin login
    loginUser: builder.mutation({
      query: (data) => ({
        url: "/admin/login",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);

          if (data && data?.token) {
            dispatch(setToken(data?.token));
          }
        } catch (error) {}
      },
      invalidatesTags: ["AuthApi"],
    }),

    sendOtp: builder.mutation({
      query: (data) => ({
        url: "/user/send-otp",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),

    // users Login
    login: builder.mutation({
      query: (data) => ({
        url: "/user/login",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    verifyOTP: builder.mutation({
      query: (data) => ({
        url: "/user/verify_otp",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    createAccount: builder.mutation({
      query: (data) => ({
        url: "/user/register",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    verifyRegisterOTP: builder.mutation({
      query: (data) => ({
        url: "/user/verify_register",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    visitorCount: builder.mutation({
      query: (data) => ({
        url: "/visitor/hit",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    getVisitorCount: builder.query({
      query: () => ({
        url: `/visitor/count`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["AuthApi"],
    }),
    // getViewUserProfile: builder.query({
    //   query: (phoneNumber) => ({
    //     url: `/user/viewUserProfile/${phoneNumber}`,
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json; charset=UTF-8",
    //     },
    //   }),
    //   providesTags: ["AuthApi"],
    // }),
  }),
});

export const {
  useLoginUserMutation,
  useSendOtpMutation,
  useVerifyOTPMutation,
  useCreateAccountMutation,
  useVerifyRegisterOTPMutation,
  useLoginMutation,
  useVisitorCountMutation,
  useGetVisitorCountQuery,
} = AuthApi;
